<div class="card shadow-sm border-0 p-4 login-card">
  <div class="text-center mb-4">
    <h2 class="fw-bold mb-2">Bem-vindo</h2>
    <p class="text-muted small">Acesse o seu LawServices</p>
  </div>

  <form [formGroup]="formLogin" id="formLogin" autocomplete="off" (ngSubmit)="logar()">
    <div class="mb-3">
      <label class="form-label small fw-semibold" for="email">Email</label>
      <div class="input-group">
        <span class="input-group-text bg-white border-end-0"><i class="fa fa-envelope-o text-muted"></i></span>
        <input type="email" formControlName="email" placeholder="advogado@exemplo.com.br" id="email"
               class="form-control border-start-0 ps-0" />
      </div>
      <div *ngIf="formLogin.controls['email'].touched && formLogin.controls['email'].invalid" class="text-danger small mt-1">
        <span *ngIf="formLogin.controls['email'].errors?.required">O email não pode ser vazio</span>
        <span *ngIf="formLogin.controls['email'].errors?.email">Email com formato inválido</span>
      </div>
    </div>

    <div class="mb-3">
      <div class="d-flex justify-content-between align-items-center mb-1">
        <label class="form-label small fw-semibold mb-0" for="senha">Senha</label>
        <a class="small text-primary-custom text-decoration-none fw-semibold" href="auth/esqueci-senha">Esqueci a senha?</a>
      </div>
      <div class="input-group">
        <span class="input-group-text bg-white border-end-0"><i class="fa fa-lock text-muted"></i></span>
        <input [type]="mostrarSenha ? 'text' : 'password'" formControlName="senha" placeholder="........" id="senha"
               class="form-control border-start-0 border-end-0 ps-0" />
        <span class="input-group-text bg-white border-start-0 cursor-pointer" (click)="toggleMostrarSenha()">
          <i class="fa text-muted" [ngClass]="mostrarSenha ? 'fa-eye' : 'fa-eye-slash'"></i>
        </span>
      </div>
      <div *ngIf="formLogin.controls['senha'].touched && formLogin.controls['senha'].invalid" class="text-danger small mt-1">
        <span *ngIf="formLogin.controls['senha'].errors?.required">A senha não pode ser vazia</span>
        <span *ngIf="formLogin.controls['senha'].errors?.maxlength">A senha tem que ter até 20 caracteres</span>
      </div>
    </div>

    <div class="mb-4 form-check">
      <input type="checkbox" class="form-check-input" id="rememberMe" formControlName="lembrarMe">
      <label class="form-check-label small text-muted cursor-pointer" for="rememberMe">Lembrar de mim</label>
    </div>

    <div class="mb-4">
      <button class="btn btn-primary-custom w-100 py-2 fw-semibold" type="submit">Fazer login</button>
    </div>

    <hr class="my-4 text-muted opacity-25">

    <div class="text-center mt-4">
      <p class="small text-muted mb-0">Não tem uma conta?
        <a href="empresa/cadastrar" class="text-primary-custom text-decoration-none fw-semibold">Nova conta</a>
      </p>
    </div>
  </form>
</div>
